import Nav from '../components/Nav';

const TermsAndConditions = () => {
  return (
    <>
      <Nav />

      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <h1>Terms & Conditions</h1>

          <div className="privacy-policy-section">
            <h2>License</h2>
            <p>
              By downloading or using the app, these terms will
              automatically apply to you - you should make sure therefore
              that you read them carefully before using the app. You are not
              allowed to copy or modify the app, any part of the app, or
              our trademarks in any way. You are not allowed to attempt to
              extract the source code of the app, and you also should not try
              to translate the app into other languages or make derivative
              versions. The app itself, and all the trademarks, copyright,
              database rights, and other intellectual property rights related
              to it, still belong to "perfect pulse" App.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>Changes to This Terms and Conditions</h2>
            <p>
              "perfect pulse" App is committed to ensuring that the app is
              as useful and efficient as possible. For that reason, we
              reserve the right to make changes to the app or to charge for
              its services, at any time and for any reason. We will never
              charge you for the app or its services without making it very
              clear to you exactly what you are paying for.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>App Responsibility</h2>
            <p>
              Along the same lines, "perfect pulse" App cannot always take
              responsibility for the way you use the app i.e. You need to
              make sure that your device stays charged - if it runs out of
              battery and you cannot turn it on to avail the Service,
              "perfect pulse" App cannot accept responsibility.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>App Provided "As Is"</h2>
            <p>
              With respect to "perfect pulse" App's responsibility for your
              use of the app, when you are using the app, it is important to
              bear in mind that although we endeavor to ensure that it is
              as useful and efficient as possible, you acknowledge that it
              is provided "as is" and we cannot promise that it will be
              without fault or interruption. You acknowledge that it is your
              responsibility to ensure that your device meets the minimum
              system requirements necessary to use the app.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>Changes to These Terms and Conditions</h2>
            <p>
              We may update our Terms and Conditions
              from time to time. Thus, you are advised to review this page
              periodically for any changes. We will
              notify you of any changes by posting the new Terms and
              Conditions on this page.
            </p>

            <p>
              These terms and conditions are effective as of October 23, 2024.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions or suggestions about our
              Terms and Conditions, do not hesitate to contact us
              at <a href="mailto:newmodeapps@gmail.com" target="_blank" rel="noopener noreferrer">newmodeapps@gmail.com</a>.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default TermsAndConditions;